// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var TailwindVariants = require("tailwind-variants");
var ReactAriaComponents = require("react-aria-components");

var tooltip = TailwindVariants.tv({
      base: "group will-change-transform bg-black/75 text-white border-none rounded-md pl-2.5 pr-2.5 pt-1.5 pb-1.5 text-sm",
      variants: {
        isEntering: {
          true: "animate-in fade-in ease-out duration-200"
        },
        isExiting: {
          true: "animate-out fade-out ease-in duration-150"
        }
      }
    });

var Styles = {
  tooltip: tooltip
};

function Tooltip(props) {
  return JsxRuntime.jsxs(ReactAriaComponents.TooltipTrigger, {
              children: [
                JsxRuntime.jsx(ReactAriaComponents.Pressable, {
                      children: props.children
                    }),
                JsxRuntime.jsx(ReactAriaComponents.Tooltip, {
                      placement: "bottom left",
                      children: JsxRuntime.jsx("div", {
                            children: props.label
                          }),
                      ariaLabel: props.ariaLabel,
                      className: (function (renderProps) {
                          return tooltip(renderProps);
                        }),
                      offset: 7.5
                    })
              ],
              delay: 200
            });
}

var make = Tooltip;

exports.Styles = Styles;
exports.make = make;
/* tooltip Not a pure module */
